import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { SCREEN_ID_SUNSETUP_ITEM_REGISTER } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withGeolocation from 'client/helpers/withGeolocation';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrCard, {
  SR_CARD_BULLET_COLOR_BLUE,
  SR_CARD_CONTENT_TYPE_FORM_REGULAR,
} from 'client/components/SrCard/SrCard';
import SrInventoryItemScanForm, {
  FORM_TYPE_REGISTER,
} from 'client/components/SrInventoryItemScanForm';
import SrBox from 'client/components/SrBox';

@withGeolocation
@withTransitionHook
@withScreenId(SCREEN_ID_SUNSETUP_ITEM_REGISTER)
@withScrollToTop
class SunSetupItemRegisterPage extends Component {
  static propTypes = {
    requestGeolocationPermission: PropTypes.func.isRequired,
    getCurrentLocation: PropTypes.func.isRequired,
  };

  render() {
    const { location, requestGeolocationPermission, getCurrentLocation } = this.props;

    const backUrl = queryString.parse(location.search).backUrl || null;

    return (
      <SrPartnerPageV2 navbarTitle="SunSetup" backUrl={backUrl}>
        <SrCard
          color={SR_CARD_BULLET_COLOR_BLUE}
          contentType={SR_CARD_CONTENT_TYPE_FORM_REGULAR}
          header="Scan Item"
        >
          <SrBox marginTop="24px">
            <SrInventoryItemScanForm
              requestGeolocationPermission={requestGeolocationPermission}
              getCurrentLocation={getCurrentLocation}
              formType={FORM_TYPE_REGISTER}
            />
          </SrBox>
        </SrCard>
      </SrPartnerPageV2>
    );
  }
}

SunSetupItemRegisterPage.displayName = 'SunSetupItemRegisterPage';

export default SunSetupItemRegisterPage;
